import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Shield02({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.125 41.625C30.425 36.1125 36.125 26.2875 36.125 15.3375V9.675L21.125 4.125L6.125 9.675V15.3375C6.125 26.2875 11.825 36.1125 21.125 41.625Z"
          fill="white"
        />
        <path
          d="M30.8375 40.9125C27.9125 37.9875 27.9125 33.225 30.8375 30.3C33.6875 27.45 38.2625 27.375 41.225 30.075C41.3 30.15 40.9625 31.0125 41.0375 31.0875C41.3375 31.3875 42.0125 31.725 42.2375 31.8375C42.35 31.875 42.05 32.2125 42.1625 32.2125C42.2 32.2125 42.6126 31.7625 42.6501 31.8375C44.3001 34.6875 43.8876 38.4375 41.4501 40.875C38.4876 43.875 33.7625 43.875 30.8375 40.9125Z"
          fill="#25B697"
        />
        <path
          d="M34.4001 33.45C34.0251 32.9625 33.3126 32.8875 32.8251 33.2625C32.3376 33.6375 32.2626 34.35 32.6376 34.8375L35.2626 38.2125C35.4501 38.475 35.7876 38.625 36.1251 38.6625H36.1626C36.5001 38.6625 36.8 38.5125 36.9875 38.2875L42.6501 31.9125C42.2751 31.2375 41.7875 30.6375 41.225 30.15L36.2001 35.775L34.4001 33.45Z"
          fill="white"
        />
        <path
          d="M21.125 42.75C20.9375 42.75 20.75 42.7125 20.5625 42.6C10.8125 36.825 5 26.625 5 15.3375V9.675C5 9.1875 5.3 8.775 5.75 8.625L20.75 3.075C21.0125 3 21.275 3 21.5375 3.075L36.5 8.625C36.95 8.775 37.25 9.225 37.25 9.675V15.3375C37.25 18.2625 36.8375 21.1875 36.05 24C35.9 24.6 35.2625 24.9375 34.6625 24.7875C34.0625 24.6375 33.725 24 33.875 23.4C34.625 20.8125 34.9625 18.1125 34.9625 15.375V10.5L21.125 5.325L7.25 10.4625V15.3375C7.25 25.8375 12.65 35.2875 21.6875 40.65C22.2125 40.95 22.4 41.6625 22.1 42.1875C21.875 42.5625 21.5 42.75 21.125 42.75Z"
          fill="#2B2D2E"
        />
        <path
          d="M21.125 42.75C20.75 42.75 20.375 42.5625 20.15 42.1875C19.85 41.6625 20 40.95 20.5625 40.65C21.7625 39.9375 22.925 39.15 24.0125 38.2875C24.5 37.9125 25.2125 37.9875 25.5875 38.475C25.9625 38.9625 25.8875 39.675 25.4 40.05C24.2375 40.9875 23 41.85 21.6875 42.6C21.5 42.7125 21.3125 42.75 21.125 42.75Z"
          fill="#2B2D2E"
        />
        <path
          d="M21.125 37.35C20.9 37.35 20.6375 37.275 20.45 37.125C14.4875 32.7375 10.7 26.25 9.72497 18.9375C9.64997 18.3375 10.0625 17.775 10.7 17.6625C11.3 17.5875 11.8625 18 11.975 18.6375C12.8375 25.05 16.0625 30.75 21.125 34.7625C27.0875 30.0375 30.5 22.9875 30.5 15.3V13.575L21.125 10.125L11 13.875C10.4 14.1 9.76247 13.8 9.53747 13.2C9.31247 12.6 9.61247 11.9625 10.2125 11.7375L20.75 7.875C21.0125 7.8 21.275 7.8 21.5375 7.875L32.0375 11.775C32.4875 11.925 32.7875 12.375 32.7875 12.825V15.3375C32.7875 24.0375 28.8125 31.9875 21.8375 37.125C21.6125 37.275 21.35 37.35 21.125 37.35Z"
          fill="#B4B5B6"
        />
        <path
          d="M21.125 8.925V36.225C27.7625 31.3125 31.625 23.7 31.625 15.3375V12.825L21.125 8.925Z"
          fill="#B4B5B6"
        />
      </svg>
    </div>
  )
}

Shield02.propTypes = {
  className: PropTypes.string,
}
